/**
 * @generated SignedSource<<f00f53af0786e16cb7fb3c77038243d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceLayoutPrimaryContextProvider_viewer$data = {
  readonly itemRead: ReadonlyArray<{
    readonly isMultiSku?: boolean;
    readonly seller?: {
      readonly isAccessible: boolean | null;
    } | null;
    readonly skus?: ReadonlyArray<{
      readonly skuId: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"useDefaultSkuId_viewer">;
  readonly " $fragmentType": "PdpRespMarketplaceLayoutPrimaryContextProvider_viewer";
};
export type PdpRespMarketplaceLayoutPrimaryContextProvider_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceLayoutPrimaryContextProvider_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceLayoutPrimaryContextProvider_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceLayoutPrimaryContextProvider_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDefaultSkuId_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMultiSku",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSkuType",
              "kind": "LinkedField",
              "name": "skus",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "skuId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Seller",
              "kind": "LinkedField",
              "name": "seller",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAccessible",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "acea06622ad122032ac70e59b9d818c3";

export default node;
